import React, { useMemo } from 'react';
import {
  Colors,
  Divider,
  Flex,
  Headline,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';
import { useGoodsDetail } from '../../../../../queries/useGoodsDetail';
import { isNil } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';

const FOLDED_COUNT = 10;

export const RelatedTags: React.FC<{
  onChangeHeight: (height: number) => void;
}> = props => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const { data: goodsDetail } = useGoodsDetail();
  const { openDeeplink } = useOpenDeeplink();

  const tags = useMemo(() => {
    if (isNil(goodsDetail)) return [];

    if (isNil(goodsDetail.goods.hash_tags)) return [];

    if (isExpanded) {
      return goodsDetail.goods.hash_tags.items;
    }

    return goodsDetail.goods.hash_tags.items.slice(0, FOLDED_COUNT);
  }, [goodsDetail, isExpanded]);
  if (isNil(goodsDetail)) return null;
  if (isNil(goodsDetail.goods.hash_tags)) return null;

  return (
    <Flex
      onLayout={({ nativeEvent }) => {
        props.onChangeHeight(nativeEvent.layout.height);
      }}
    >
      <Divider size={'small'} />
      <Headline headline={goodsDetail.goods.hash_tags.title} size={'medium'} />

      <Flex.Row
        flexWrap={'wrap'}
        padding={{ horizontal: 16 }}
        rowGap={8}
        columnGap={4}
      >
        {tags.map((tag, index) => (
          <Flex
            key={`${tag}-${index}`}
            padding={{ horizontal: 16, vertical: 10 }}
            backgroundColor={'bg_secondary'}
            borderColorValue={Colors.bg_secondary}
            borderRadius={30}
            onPress={() => {
              openDeeplink(`ably://search?query=${tag}&from=GOODS_DETAIL`);
            }}
          >
            <Typography type={'subtitle4'} color={'content_secondary'}>
              {tag}
            </Typography>
          </Flex>
        ))}
      </Flex.Row>

      <Flex padding={{ horizontal: 16, top: 16, bottom: 24 }}>
        {goodsDetail.goods.hash_tags.items.length > FOLDED_COUNT && (
          <PrimaryButton
            color="gray"
            size="large"
            variant={'fill'}
            outline
            onPress={() => {
              /* INPUT YOUR FUNCTION LOGIC*/
              setIsExpanded(prev => !prev);
            }}
          >
            {isExpanded
              ? `${goodsDetail.goods.hash_tags.title} 접기`
              : `${goodsDetail.goods.hash_tags.title} 전체 보기`}
          </PrimaryButton>
        )}
      </Flex>
    </Flex>
  );
};
